import React, { ComponentProps } from "react";

export default function CheckmarkCircleIconWithBorder(
  props: ComponentProps<"svg">
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      {...props}
    >
      <rect x="0.5" width="60" height="60" rx="30" fill="#FAFAFA" />
      <circle cx="30" cy="30" r="20" fill="#5ABF83" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.4258 24.2856L26.5686 35.7142L21.4258 29.9999"
        fill="#5ABF83"
      />
      <path
        d="M37.4258 24.2856L26.5686 35.7142L21.4258 29.9999"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
